/*
 * @Author: liqiang70 liqiang70@58.com
 * @Date: 2025-05-14 16:05:40
 * @LastEditors: liqiang70 liqiang70@58.com
 * @LastEditTime: 2025-05-15 09:33:05
 * @Description: 
 */
import 'whatwg-fetch'
import 'scss_mixin/reset.scss' //reset 样式
import 'tools/polyfill'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router } from "react-router-dom";
import App from './containers/App';
import './index.scss';

const rootElement = document.getElementById('root');

ReactDOM.createRoot(rootElement!).render(
    <React.Suspense fallback={<div></div>}>
        <Router basename="/">
            <App />
        </Router>
    </React.Suspense>
);